import { AlertContext } from "contexts/AlertContext"
import { POST } from "api/request"
import { useContext } from "react"
import * as url from 'api/urls'
import Modal from "./Modal"

interface NotificationModalProps {
  onClose: () => void
  onReload: () => void
  body: notifications.Related | null | undefined
  notificationId: string
}

const NotificationModal: React.FC<NotificationModalProps> = ({ body, notificationId, onClose, onReload }) => {
  const { showAlert } = useContext(AlertContext)

  const primButton = () => {
    if (body?.object === 'Candle') {
      handleSubmit('reject')
      onClose()
    } else {
      handleSubmit('accept')
      onClose()
    }
  }

  const secButton = () => {
    if (body?.object === 'BookEntry' || body?.object === 'Media') {
      handleSubmit('remove')
      window.history.back() 
      onClose()
    } else if (body?.object === 'Candle') {
      window.history.back() 
      onClose()
    } else {
      return
    }
  }

  const handleSubmit = async (action: string) => {
    try {
      const response = await POST(url.notificationAction(notificationId), {
        body: {
          action: action
        }
      })
      if (response.ok) {
        onReload()
        window.history.back() 
        onClose()
        showAlert(action, 'success')
      } else {
        showAlert('Wystąpił błąd', 'error')
      }
    } catch (err) {
      console.error(err)
    }
  }


  return (
    <Modal
      icon={body?.object === 'BookEntry' ? 'book' : body?.object === 'Candle' ? 'candle' : 'add-photo'}
      onClose={onClose}
      title={body?.object === 'BookEntry' ? 'Wpis do zaakceptowania' : body?.object === 'Candle' ? 'Zapalono wirtualny znicz' : 'Media do akceptacji'}
      isLargeButton
      primaryButton={body?.object === 'BookEntry' ? 'Upublicznij wpis' : body?.object === 'Candle' ? 'Usuń powiadomienie' : 'Upublicznij media'} primaryButtonAction={primButton}
      secondaryButton={body?.object === 'BookEntry' ? 'Usuń wpis' : body?.object === 'Candle' ? 'Anuluj' : 'Usuń media'} secondaryButtonAction={secButton}>
      <div className="notification__modal">
        {
          body?.object === 'BookEntry'
            ? <div className="bookEntry">
              <div>
                <label>Dodany przez:</label>
                <div>{body.signature}</div>
              </div>
              <div>
                <label>Utworzony:</label>
                <div>{body.readable_created_at}</div>
              </div>
              <div className="content">
                <label>Treść wpisu:</label>
                <div>{body.text}</div>
              </div>
            </div>
            : body?.object === 'Candle'
              ? <div className="info">
                {body.readable_created_at} {body.signature ? body.signature : "Anonim"} zapalił wirtualny znicz
              </div>
              : <div className="imgWrap"><img src={body?.url} alt={body?.displayName} /></div>
        }
      </div>
    </Modal>
  )
}

export default NotificationModal